module.exports = __webpack_public_path__ + "static/media/3.a0e3c016.png";